<template>
    <section class="popular-product">
        <title-date-component :titleOption="titleOption" :initDateRange="initDateRange" @changeDate="changeDate"></title-date-component>
        <section class="data-box">
            <rose-component style="width:300px;" :roseInfo="roseInfo"></rose-component>
            <table-component style="width:62%; margin-left:4%;" :tableInfo="tableInfo"></table-component>
        </section>
        <tips-component :info="info"></tips-component>
    </section>
</template>

<style lang="scss" scoped="scoped">
    .popular-product {
        background-color: #FFF;
	    padding: 30px 20px 10px 20px;
        margin-top: 15px;
        .data-box {
            width: 100%;
            height: 300px;
            padding-left: 40px;
            margin-top: 35px;
        }
    }
</style>

<script>
    import TitleDateComponent from '../../../components/title-date/TitleDate.vue'
    import RoseComponent from '../../../components/echarts/Rose.vue'
    import TableComponent from '../../../components/table/Table.vue'
    import TipsComponent from '../../../components/tips/Tips.vue'
    import DataPlatform from 'api/dataPlatform'
    import MomentFormat from '../../../filters/moment-format'
    import percentformat from '../../../filters/percent-format'

    export default {
        components: {
            TitleDateComponent,
	        RoseComponent,
	        TableComponent,
            TipsComponent
        },
        data () {
            return {
                titleOption: {  // 单元块名称和日期选择配置
                    title: '畅销商品',  // 名称
                    dateRadio: false,    // 是否显示昨天、本周、本月日期单选框
                    dateRangeSelect: true, // 是否显示日期区间下拉框
                    download: true, // 是否显示下载按钮
	                moduleId: 5,
	                bizCode: this.bizCode,
	                productId: [],
	                showDate: {
		                startDate: MomentFormat.getSevenDate(),
		                endDate: MomentFormat.getYestoday()
	                }
                },
	            rankType: 1,
	            startDate: MomentFormat.getSevenDate(),  // 开始日期，默认昨天
	            endDate: MomentFormat.getYestoday(), // 结束日期，默认昨天
	            initDateRange: MomentFormat.getSevenDate() + ' ~ ' + MomentFormat.getYestoday(),
                roseInfo: [],   // 南丁格尔图数据
                tableInfo: {    // 表格数据
	                title: [
		                {
			                name: '商品名称',
                            value: 'productName',
                            style: 'width:25%;'
		                },
		                {
			                name: '销量',
			                value: 'payQuantity'
		                },
		                {
			                name: '销售额',
			                value: 'payAmt'
		                },
		                {
			                name: '销售占比',
			                value: 'saleProportion'
		                },
		                {
			                name: '支付转化率',
			                value: 'payConversionRate'
		                },
		                {
			                name: '',
			                value: 'action'
		                }
	                ],
                    data: []
                },
	            info: {
		            value: 1,
		            suggest: "这里为您展示了销量最好的top5商品，你可以特别关注这些为您带来主要收入的商品，点击“查看趋势”可以看具体数据趋势情况。同时根据畅销商品分析原因，改善您的其他商品的销售情况。"
	            },
                color: ['#FF2F40', '#FFBC37', '#139BFD', '#1DD978', '#4D7BF3']
            }
        },
        props: ["bizCode"],
        methods: {
	        // 获取单品数据
	        getRankTypeData () {
		        DataPlatform.getRankTypeData(this.bizCode, this.startDate, this.endDate, this.rankType)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            let data = res.data;
                            let arr = [];
                            let roseArr = [];
                            let productId = [];
                            data.forEach((item, index) => {
                                let o = {};
                                o.productName = {};
                                o.productName.value = '<span style="background-color:' + this.color[index] + '">' +
                                    (index + 1) + '</span>' + item.productName;
                                o.payQuantity = {};
                                o.payQuantity.value = item.payQuantity;
                                o.payAmt = {};
                                o.payAmt.value = item.payAmt;
                                o.saleProportion = {};
                                o.saleProportion.value = percentformat(item.saleProportion, true);
                                o.payConversionRate = {};
                                o.payConversionRate.value = percentformat(item.payConversionRate, true);
                                o.action = {};
                                o.action.value = '<a href="javascript:void(0);">查看趋势</a>';
                                o.action.showTc = true;
                                o.action.params = {
	                                productId: item.productId,
	                                productName: item.productName,
	                                startDate: this.startDate,
                                    endDate: this.endDate
                                };
	                            roseArr.push({
                                    name: item.productName,
                                    value: item.payAmt,
                                    color: this.color[index]
                                });
	                            productId.push(item.productId);
                                arr.push(o);
                            });
                            this.roseInfo = roseArr;
	                        this.tableInfo.data = arr;
	                        this.titleOption.productId = productId;
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    })
	        },

	        // 切换日期
	        changeDate (params) {
		        this.startDate = params.dateRange.startDate;
		        this.endDate = params.dateRange.endDate;
		        this.getRankTypeData();
	        }
        },
	    mounted () {
		    this.getRankTypeData();
	    }
    }
</script>



// WEBPACK FOOTER //
// PopularProduct.vue?5b197f70